export default "__VITE_ASSET__B7xe3AQT__"